{
  "valid": "Veljavno"
}
